import React from 'react';
import { AppBar, Layout, MenuItemLink, UserMenu, WithPermissions } from 'react-admin';
import SettingsIcon from '@material-ui/icons/Settings';

const MyUserMenu = props => (
  <WithPermissions
    render={({ permissions }) => (
      <UserMenu {...props}>
        {permissions && permissions.name !== 'Default Team - For Self Signups' &&
          <MenuItemLink to="/profiles/1" primaryText="Profile" leftIcon={<SettingsIcon />} />
        }
      </UserMenu>
    )}
  />
);

const MyAppBar = props => <AppBar {...props} userMenu={<MyUserMenu />} />;

const MyLayout = props => <Layout {...props} appBar={MyAppBar} />;

export default MyLayout;



// WEBPACK FOOTER //
// ./src/views/Framework/Layout.tsx